function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteSx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.51 24.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.03,0l-6.45,24.83h12.41L34.51,0h-9.48ZM6.45,0L0,24.83h12.42L15.93,0H6.45Z",
    style: {
      fill: "#164891"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteSx);
export default __webpack_public_path__ + "static/media/quote-sx.7953972d9c9b32a492269ae8615831e2.svg";
export { ForwardRef as ReactComponent };